/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const AddressType = {
    ACTUAL: 'ACTUAL',
    LEGAL: 'LEGAL'
} as const;
export type AddressType = typeof AddressType[keyof typeof AddressType];

